import React, { useEffect, useState } from 'react';
import SalesReportChart from '../components/SalesReportChart';
import OrdersOverviewChart from '../components/OrdersOverview';
import UserActivityChart from '../components/charts/UserActivityChart';
import CurrentUsersChart from '../components/charts/CurrentUsersChart';
import HorizontalBarChart from '../components/charts/HorizontalBarChart';
import WorldMap from '../components/charts/WorldMap';
import { api } from '../api';

function Dashboard() {
  const [metrics, setMetrics] = useState({ users: 0, sellers: 0, products: 0, orders: 0, revenue: 0 });
  const [loadingMetrics, setLoadingMetrics] = useState(true);
  const [salesMetrics, setSalesMetrics] = useState({ salesBySeller: [], salesByCategory: [], salesByCommunity: [] });
  const [loadingSales, setLoadingSales] = useState(true);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const [users, sellers, products, orders, revenue] = await Promise.all([
          api.getUserMetrics(),
          api.getSellerMetrics(),
          api.getProductMetrics(),
          api.getOrderMetrics(),
          api.getRevenueMetrics(),
        ]);
        if (!isMounted) return;
        setMetrics({ users, sellers, products, orders, revenue });
      } catch (e) {
        // noop, defaults remain 0
      } finally {
        if (isMounted) setLoadingMetrics(false);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const data = await api.getSalesMetrics();
        if (!isMounted) return;
        setSalesMetrics({
          salesBySeller: Array.isArray(data?.salesBySeller) ? data.salesBySeller : [],
          salesByCategory: Array.isArray(data?.salesByCategory) ? data.salesByCategory : [],
          salesByCommunity: Array.isArray(data?.salesByCommunity) ? data.salesByCommunity : [],
        });
      } catch (e) {
        // ignore, defaults remain
      } finally {
        if (isMounted) setLoadingSales(false);
      }
    })();
    return () => { isMounted = false; };
  }, []);
  return (
    <div className="ec-content-wrapper">
      <div className="content">
        {/* Top Statistics */}
        {/* <div className="row">
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-1">
              <div className="card-body">
                <h2 className="mb-1">1,503</h2>
                <p>Daily Signups</p>
                <span className="mdi mdi-account-arrow-left"></span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-2">
              <div className="card-body">
                <h2 className="mb-1">79,503</h2>
                <p>Daily Visitors</p>
                <span className="mdi mdi-account-clock"></span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-3">
              <div className="card-body">
                <h2 className="mb-1">15,503</h2>
                <p>Daily Order</p>
                <span className="mdi mdi-package-variant"></span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-4">
              <div className="card-body">
                <h2 className="mb-1">$98,503</h2>
                <p>Daily Revenue</p>
                <span className="mdi mdi-currency-usd"></span>
              </div>
            </div>
          </div>
        </div> */}

        {/* Additional Top Metrics */}
        <div className="row">
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-1">
              <div className="card-body">
                <h2 className="mb-1">{loadingMetrics ? '...' : metrics.users}</h2>
                <p>Total Users</p>
                <span className="mdi mdi-account-multiple-outline"></span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-2">
              <div className="card-body">
                <h2 className="mb-1">{loadingMetrics ? '...' : metrics.sellers}</h2>
                <p>Total Sellers</p>
                <span className="mdi mdi-storefront-outline"></span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-3">
              <div className="card-body">
                <h2 className="mb-1">{loadingMetrics ? '...' : metrics.products}</h2>
                <p>Total Products</p>
                <span className="mdi mdi-package-variant"></span>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-4">
              <div className="card-body">
                <h2 className="mb-1">{loadingMetrics ? '...' : metrics.orders}</h2>
                <p>Total Orders</p>
                <span className="mdi mdi-cart-outline"></span>
              </div>
            </div>
          </div>
        </div>

        {/* Revenue Metric */}
        <div className="row">
          <div className="col-xl-3 col-sm-6 p-b-15 lbl-card">
            <div className="card card-mini dash-card card-4">
              <div className="card-body">
                <h2 className="mb-1">{loadingMetrics ? '...' : metrics.revenue}</h2>
                <p>Total Revenue</p>
                <span className="mdi mdi-currency-usd"></span>
              </div>
            </div>
          </div>
        </div>

        {/* Sales Metrics */}
        <div className="row">
          <div className="col-xl-4 col-12 p-b-15">
            <div className="card card-default Sold-card-table">
              <div className="card-header justify-content-between">
                <h2>Sales by Seller</h2>
              </div>
              <div className="card-body py-0 compact-units" style={{ height: '320px', overflow: 'auto' }}>
                <table className="table">
                  <tbody>
                    {(loadingSales ? [] : salesMetrics.salesBySeller).map((it, idx) => (
                      <tr key={idx}>
                        <td className="text-dark">{it.sellerName || it.sellerId}</td>
                        <td className="text-right">{it.totalSales}</td>
                      </tr>
                    ))}
                    {(!loadingSales && (!salesMetrics.salesBySeller || salesMetrics.salesBySeller.length === 0)) ? (
                      <tr><td colSpan="2" className="text-center text-muted">No data</td></tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-12 p-b-15">
            <div className="card card-default Sold-card-table">
              <div className="card-header justify-content-between">
                <h2>Sales by Category</h2>
              </div>
              <div className="card-body py-0 compact-units" style={{ height: '320px', overflow: 'auto' }}>
                <table className="table">
                  <tbody>
                    {(loadingSales ? [] : salesMetrics.salesByCategory).map((it, idx) => (
                      <tr key={idx}>
                        <td className="text-dark d-flex align-items-center">
                          {it.categoryIcon ? <img src={it.categoryIcon} alt={it.categoryName} style={{ width: 18, height: 18, objectFit: 'cover', marginRight: 6 }} /> : null}
                          {it.categoryName || 'Uncategorized'}
                        </td>
                        <td className="text-right">{it.totalSales}</td>
                      </tr>
                    ))}
                    {(!loadingSales && (!salesMetrics.salesByCategory || salesMetrics.salesByCategory.length === 0)) ? (
                      <tr><td colSpan="2" className="text-center text-muted">No data</td></tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-12 p-b-15">
            <div className="card card-default Sold-card-table">
              <div className="card-header justify-content-between">
                <h2>Sales by Community</h2>
              </div>
              <div className="card-body py-0 compact-units" style={{ height: '320px', overflow: 'auto' }}>
                <table className="table">
                  <tbody>
                    {(loadingSales ? [] : salesMetrics.salesByCommunity).map((it, idx) => (
                      <tr key={idx}>
                        <td className="text-dark d-flex align-items-center">
                          {it.communityIcon ? <img src={it.communityIcon} alt={it.communityName} style={{ width: 18, height: 18, objectFit: 'cover', marginRight: 6 }} /> : null}
                          {it.communityName || 'Unassigned'}
                        </td>
                        <td className="text-right">{it.totalSales}</td>
                      </tr>
                    ))}
                    {(!loadingSales && (!salesMetrics.salesByCommunity || salesMetrics.salesByCommunity.length === 0)) ? (
                      <tr><td colSpan="2" className="text-center text-muted">No data</td></tr>
                    ) : null}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {/* Sales Report (Chart) */}
          <div className="col-xl-8 col-md-12 p-b-15">
            <div id="user-acquisition" className="card card-default">
              <div className="card-header">
                <h2>Sales Report</h2>
              </div>
              <div className="card-body">
                <ul className="nav nav-tabs nav-style-border justify-content-between justify-content-lg-start border-bottom"
                    role="tablist">
                  <li className="nav-item">
                    <a className="nav-link active" data-bs-toggle="tab" href="#todays" role="tab"
                       aria-selected="true">Today's</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#monthly" role="tab"
                       aria-selected="false">Monthly </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" data-bs-toggle="tab" href="#yearly" role="tab"
                       aria-selected="false">Yearly</a>
                  </li>
                </ul>
                <div className="tab-content pt-4" id="salesReport">
                  <div className="tab-pane fade show active" id="source-medium" role="tabpanel">
                    <div className="mb-6" style={{ maxHeight: '247px' }}>
                      {/* Render the Sales Report Chart component */}
                      <SalesReportChart />
                      <div id="acqLegend" className="customLegend mb-2"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Orders Overview (Chart) */}
          <div className="col-xl-4 col-md-12 p-b-15">
            <div className="card card-default">
              <div className="card-header justify-content-center">
                <h2>Orders Overview</h2>
              </div>
              <div className="card-body">
                {/* Render the Orders Overview Chart component */}
                <OrdersOverviewChart />
              </div>
              <a href="#" className="pb-5 d-block text-center text-muted" onClick={(e) => e.preventDefault()}>
                <i className="mdi mdi-download mr-2"></i> Download overall report
              </a>
              <div className="card-footer d-flex flex-wrap bg-white p-0">
                <div className="col-6">
                  <div className="p-20">
                    <ul className="d-flex flex-column justify-content-between">
                      <li className="mb-2"><i className="mdi mdi-checkbox-blank-circle-outline mr-2" style={{ color: '#4c84ff' }}></i>Order Completed</li>
                      <li className="mb-2"><i className="mdi mdi-checkbox-blank-circle-outline mr-2" style={{ color: '#80e1c1' }}></i>Order Unpaid</li>
                      <li><i className="mdi mdi-checkbox-blank-circle-outline mr-2" style={{ color: '#ff7b7b' }}></i>Order returned</li>
                    </ul>
                  </div>
                </div>
                <div className="col-6 border-left">
                  <div className="p-20">
                    <ul className="d-flex flex-column justify-content-between">
                      <li className="mb-2"><i className="mdi mdi-checkbox-blank-circle-outline mr-2" style={{ color: '#8061ef' }}></i>Order Pending</li>
                      <li className="mb-2"><i className="mdi mdi-checkbox-blank-circle-outline mr-2" style={{ color: '#ffc107' }}></i>Order Canceled</li>
                      <li><i className="mdi mdi-checkbox-blank-circle-outline mr-2" style={{ color: '#c7c1ff' }}></i>Order Lost</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* User Activity and Current Users */}
        <div className="row">
          <div className="col-xl-8 col-md-12 p-b-15">
            <div className="card card-default" id="user-activity">
              <div className="no-gutters">
                <div>
                  <div className="card-header justify-content-between">
                    <h2>User Activity</h2>
                    <div className="date-range-report "><span></span></div>
                  </div>
                  <div className="card-body">
                    <div className="tab-content" id="userActivityContent">
                      <div className="tab-pane fade show active" id="user" role="tabpanel">
                        <UserActivityChart />
                      </div>
                    </div>
                  </div>
                  <div className="card-footer d-flex flex-wrap bg-white border-top">
                    <a href="#" className="text-uppercase py-3" onClick={(e) => e.preventDefault()}>In-Detail Overview</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-md-12 p-b-15">
            <div className="card card-default">
              <div className="card-header flex-column align-items-start">
                <h2>Current Users</h2>
              </div>
              <div className="card-body">
                <CurrentUsersChart />
              </div>
              <div className="card-footer d-flex flex-wrap bg-white border-top">
                <a href="#" className="text-uppercase py-3" onClick={(e) => e.preventDefault()}>In-Detail Overview</a>
              </div>
            </div>
          </div>
        </div>

        {/* Purchased by Country and Sold by Items */}
        <div className="row">
          <div className="col-xl-8 col-12 p-b-15">
            <div className="card card-default" id="analytics-country">
              <div className="card-header justify-content-between">
                <h2>Purchased by Country</h2>
                <div className="date-range-report "><span></span></div>
              </div>
              <div className="card-body vector-map-world-2">
                <WorldMap />
              </div>
              <div className="border-top mt-3">
                <div className="row no-gutters">
                  <div className="col-lg-6">
                    <div className="world-data-chart border-bottom pt-15px pb-15px">
                      <HorizontalBarChart title="Top Countries" labels={["Nigeria","Ghana","Kenya","USA","UK"]} dataValues={[320,240,180,120,90]} color="#4c84ff" />
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="world-data-chart pt-15px pb-15px">
                      <HorizontalBarChart title="Top Cities" labels={["Lagos","Accra","Nairobi","NYC","London"]} dataValues={[210,160,130,90,70]} color="#80e1c1" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer d-flex flex-wrap bg-white">
                <a href="#" className="text-uppercase py-3" onClick={(e) => e.preventDefault()}>In-Detail Overview</a>
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-12 p-b-15">
            <div className="card card-default Sold-card-table">
              <div className="card-header justify-content-between">
                <h2>Sold by Items</h2>
                <div className="tools">
                  <button className="text-black-50 mr-2 font-size-20"><i className="mdi mdi-cached"></i></button>
                  <div className="dropdown show d-inline-block widget-dropdown">
                    <a className="dropdown-toggle icon-burger-mini" href="#" role="button" id="dropdown-units" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static" onClick={(e) => e.preventDefault()}></a>
                    <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-units">
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Action</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Another action</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Something else here</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body py-0 compact-units" style={{ height: '534px', overflow: 'auto' }}>
                <table className="table">
                  <tbody>
                    {[
                      { name: 'Backpack', qty: 9, change: '33%', dir: 'up' },
                      { name: 'T-Shirt', qty: 6, change: '150%', dir: 'up' },
                      { name: 'Coat', qty: 3, change: '50%', dir: 'up' },
                      { name: 'Necklace', qty: 7, change: '150%', dir: 'up' },
                      { name: 'Jeans Pant', qty: 10, change: '300%', dir: 'down' },
                      { name: 'Shoes', qty: 5, change: '100%', dir: 'up' },
                      { name: 'Watches', qty: 18, change: '160%', dir: 'up' },
                      { name: 'Inner', qty: 156, change: '120%', dir: 'up' },
                    ].map((it, idx) => (
                      <tr key={idx}>
                        <td className="text-dark">{it.name}</td>
                        <td className="text-center">{it.qty}</td>
                        <td className="text-right">{it.change} <i className={`mdi ${it.dir === 'up' ? 'mdi-arrow-up-bold text-success' : 'mdi-arrow-down-bold text-danger'} pl-1 font-size-12`}></i></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="card-footer d-flex flex-wrap bg-white">
                <a href="#" className="text-uppercase py-3" onClick={(e) => e.preventDefault()}>View Report</a>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Orders */}
        <div className="row">
          <div className="col-12 p-b-15">
            <div className="card card-table-border-none card-default recent-orders" id="recent-orders">
              <div className="card-header justify-content-between">
                <h2>Recent Orders</h2>
                <div className="date-range-report"><span></span></div>
              </div>
              <div className="card-body pt-0 pb-5">
                <table className="table card-table table-responsive table-responsive-large" style={{ width: '100%' }}>
                  <thead>
                    <tr>
                      <th>Order ID</th>
                      <th>Product Name</th>
                      <th className="d-none d-lg-table-cell">Units</th>
                      <th className="d-none d-lg-table-cell">Order Date</th>
                      <th className="d-none d-lg-table-cell">Order Cost</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {[
                      { id: '24541', product: 'Coach Swagger', units: '1 Unit', date: 'Oct 20, 2018', cost: '$230', status: 'Completed' },
                      { id: '24542', product: 'Toddler Shoes, Gucci Watch', units: '2 Units', date: 'Nov 15, 2018', cost: '$550', status: 'Delayed' },
                      { id: '24543', product: 'Hat Black Suits', units: '1 Unit', date: 'Nov 18, 2018', cost: '$325', status: 'On Hold' },
                      { id: '24544', product: 'Backpack Gents, Swimming Cap Slin', units: '5 Units', date: 'Dec 13, 2018', cost: '$200', status: 'Completed' },
                      { id: '24545', product: 'Speed 500 Ignite', units: '1 Unit', date: 'Dec 23, 2018', cost: '$150', status: 'Cancelled' },
                    ].map(row => (
                      <tr key={row.id}>
                        <td>{row.id}</td>
                        <td><a className="text-dark" href="#" onClick={(e) => e.preventDefault()}>{row.product}</a></td>
                        <td className="d-none d-lg-table-cell">{row.units}</td>
                        <td className="d-none d-lg-table-cell">{row.date}</td>
                        <td className="d-none d-lg-table-cell">{row.cost}</td>
                        <td>
                          <span className={`badge ${row.status === 'Completed' ? 'badge-success' : row.status === 'Delayed' ? 'badge-primary' : row.status === 'On Hold' ? 'badge-warning' : 'badge-danger'}`}>{row.status}</span>
                        </td>
                        <td className="text-right">
                          <div className="dropdown show d-inline-block widget-dropdown">
                            <a className="dropdown-toggle icon-burger-mini" href="#" role="button" id={`dropdown-recent-order-${row.id}`} data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static" onClick={(e) => e.preventDefault()}></a>
                            <ul className="dropdown-menu dropdown-menu-right" aria-labelledby={`dropdown-recent-order-${row.id}`}>
                              <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>View</a></li>
                              <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Remove</a></li>
                            </ul>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        {/* New Customers and Top Products */}
        <div className="row">
          <div className="col-xl-5">
            <div className="card ec-cust-card card-table-border-none card-default">
              <div className="card-header justify-content-between ">
                <h2>New Customers</h2>
                <div>
                  <button className="text-black-50 mr-2 font-size-20"><i className="mdi mdi-cached"></i></button>
                  <div className="dropdown show d-inline-block widget-dropdown">
                    <a className="dropdown-toggle icon-burger-mini" href="#" role="button" id="dropdown-customar" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static" onClick={(e) => e.preventDefault()}></a>
                    <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-customar">
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Action</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Another action</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Something else here</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body pt-0 pb-15px">
                <table className="table ">
                  <tbody>
                    {[
                      { img: '/assets/img/vendor/u1.jpg', name: 'Selena Wagner', handle: '@selena.oi', orders: '2 Orders', amount: '$150' },
                      { img: '/assets/img/vendor/u2.jpg', name: 'Walter Reuter', handle: '@walter.me', orders: '5 Orders', amount: '$200' },
                      { img: '/assets/img/vendor/u3.jpg', name: 'Larissa Gebhardt', handle: '@larissa.gb', orders: '1 Order', amount: '$50' },
                      { img: '/assets/img/vendor/u4.jpg', name: 'Albrecht Straub', handle: '@albrech.as', orders: '2 Orders', amount: '$100' },
                      { img: '/assets/img/vendor/u5.jpg', name: 'Leopold Ebert', handle: '@leopold.et', orders: '1 Order', amount: '$60' },
                    ].map((c, i) => (
                      <tr key={i}>
                        <td>
                          <div className="media">
                            <div className="media-image mr-3 rounded-circle">
                              <a href="#" onClick={(e) => e.preventDefault()}><img className="profile-img rounded-circle w-45" src={c.img} alt="customer image" /></a>
                            </div>
                            <div className="media-body align-self-center">
                              <a href="#" onClick={(e) => e.preventDefault()}><h6 className="mt-0 text-dark font-weight-medium">{c.name}</h6></a>
                              <small>{c.handle}</small>
                            </div>
                          </div>
                        </td>
                        <td>{c.orders}</td>
                        <td className="text-dark d-none d-md-block">{c.amount}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="col-xl-7">
            <div className="card card-default ec-card-top-prod">
              <div className="card-header justify-content-between">
                <h2>Top Products</h2>
                <div>
                  <button className="text-black-50 mr-2 font-size-20"><i className="mdi mdi-cached"></i></button>
                  <div className="dropdown show d-inline-block widget-dropdown">
                    <a className="dropdown-toggle icon-burger-mini" href="#" role="button" id="dropdown-product" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" data-display="static" onClick={(e) => e.preventDefault()}></a>
                    <ul className="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown-product">
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Update Data</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Detailed Log</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Statistics</a></li>
                      <li className="dropdown-item"><a href="#" onClick={(e) => e.preventDefault()}>Clear Data</a></li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="card-body mt-10px mb-10px py-0">
                {[
                  { img: '/assets/img/products/p1.jpg', name: 'Baby cotton shoes', sales: 58, price: '$520', old: '$580', desc: 'Statement belting with double-turnlock hardware adds “swagger” to a simple.' },
                  { img: '/assets/img/products/p2.jpg', name: 'Hoodies for men', sales: 20, price: '$250', old: '$300', desc: 'Statement belting with double-turnlock hardware adds “swagger” to a simple.' },
                  { img: '/assets/img/products/p3.jpg', name: 'Long slive t-shirt', sales: 10, price: '$480', old: '$654', desc: 'Statement belting with double-turnlock hardware adds “swagger” to a simple.' },
                ].map((p, i) => (
                  <div className="row media d-flex pt-15px pb-15px" key={i}>
                    <div className="col-lg-3 col-md-3 col-2 media-image align-self-center rounded">
                      <a href="#" onClick={(e) => e.preventDefault()}><img src={p.img} alt="product" /></a>
                    </div>
                    <div className="col-lg-9 col-md-9 col-10 media-body align-self-center ec-pos">
                      <a href="#" onClick={(e) => e.preventDefault()}><h6 className="mb-10px text-dark font-weight-medium">{p.name}</h6></a>
                      <p className="float-md-right sale"><span className="mr-2">{p.sales}</span>Sales</p>
                      <p className="d-none d-md-block">{p.desc}</p>
                      <p className="mb-0 ec-price"><span className="text-dark">{p.price}</span> <del>{p.old}</del></p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="footer mt-auto">
        <div className="copyright bg-white">
          <p>
            Copyright &copy; <span id="ec-year"></span>
            <a className="text-primary" href="https://Owena.com" target="_blank" rel="noopener noreferrer">
              Owena Admin Dashboard
            </a>. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};
export default Dashboard;